<template>
  <v-container v-if="showingAnyMessage">
    <v-layout class="headline font-weight-light blue-grey--text">
      <v-flex>
        <template v-for="(message, index) in messages">
          <v-layout v-if="message.flag" align-center justify-center fill-height :key="index">
            <v-flex class="text-xs-center">
              <!-- A spinner to show with the message -->
              <v-pulse-loader v-if="message.spinner" loading />
              <!-- The info message -->
              <span>{{ message.text }}</span>
            </v-flex>
          </v-layout>
        </template>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import VPulseLoader from "vue-spinner/src/PulseLoader";

/**
 * A useful component to show spinners with messages while loading some data.
 *
 * Usage:
 * ```
 * <v-loading-messages :messages="messages" :showing-any-message.sync="showingAnyMessage" />
 * ```
 *
 * Where `messages` must be an array with objects like:
 * ```
 * [{
 *   flag: Boolean that indicates if the message will be shown,
 *   text: String with the content of the message,
 *   spinner: Boolean that indicates if a spinner must be used to show it with the message
 * }]
 * ```
 *
 * And the `showingAnyMessage` is a `sync` property optional to knwo if the component is showing a message
 * or not.
 */
export default {
  components: {
    VPulseLoader
  },
  props: {
    messages: {
      type: Array,
      required: true,
      validator: array => array.every(message => !!message.text)
    }
  },
  computed: {
    showingAnyMessage() {
      return this.messages.some(message => message.flag);
    }
  },
  created() {
    this.updateShowingAnyMessage();
  },
  watch: {
    showingAnyMessage() {
      this.updateShowingAnyMessage();
    }
  },
  methods: {
    updateShowingAnyMessage() {
      this.$emit("update:showingAnyMessage", this.showingAnyMessage);
    }
  }
};
</script>